// export const BET_BASE_URL = 'https://fifa.gobizdev.com/api';
// export const LOGIN_URL = 'https://fifa.gobizdev.com/api/auth/gobiz';
export const BET_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;